export class TranslationEs {

  static readonly dict =
    {
      'advise.info.not_supported_audio': 'Your browser does not support the <code>audio</code> element.',
      'assignment_method': 'Asignación',
      'assignment_method.competitive': 'Competitiva',
      'assignment_method.manual': 'Manual',
      'assignment_method.prequalification': 'Precualificación Competitiva',
      'auth.labels.logout': 'Desconectar',
      'auth.profile': 'Mi perfil',
      'brand.leads.chart.no_brand': 'Sin marca',
      'calendar.add_event': 'Añadir evento',
      'calendar.confirm_visit': 'Reportar visita',
      'calendar.scheduler': 'Agendar',
      'call.has.another.started.call': 'Tienes otra llamada en curso.',
      'call.started.call': 'Llamada en curso: ',
      'call.view.lead': 'Ver Lead',
      'call.view.lead_with_link': 'Tienes otro lead en interacción. Ver Lead',
      'channel.to.day.week.leads.chart.bar': 'Barras',
      'channel.to.day.week.leads.chart.day.name': 'Día de la semana',
      'channel.to.day.week.leads.chart.day.name.friday': 'Viernes',
      'channel.to.day.week.leads.chart.day.name.monday': 'Lunes',
      'channel.to.day.week.leads.chart.day.name.saturday': 'Sábado',
      'channel.to.day.week.leads.chart.day.name.sunday': 'Domingo',
      'channel.to.day.week.leads.chart.day.name.thursday': 'Jueves',
      'channel.to.day.week.leads.chart.day.name.tuesday': 'Martes',
      'channel.to.day.week.leads.chart.day.name.wednesday': 'Miércoles',
      'channel.to.day.week.leads.chart.leads.count': 'Número de leads',
      'channel.to.day.week.leads.chart.line': 'Líneas',
      'channel.to.day.week.leads.chart.stack': 'Apilar',
      'channel.to.day.week.leads.chart.tiled': 'Agrupar',
      'channel.to.day.week.leads.chart.undefined': 'Sin especificar',
      'channel.to.hour.leads.chart.day.hour': 'Hora del día',
      'channel.to.hour.leads.chart.leads.count': 'Número de leads',
      'channel.to.hour.leads.chart.stack': 'Apilar',
      'channel.to.hour.leads.chart.tiled': 'Agrupar',
      'channel.to.hour.leads.chart.undefined': 'Sin especificar',
      'chat.show_hidden': 'Mostrar/Ocultar chat',
      'chat.support': 'Soporte',
      'concurrence.time.0': 'Día actual',
      'concurrence.time.1': '1 día',
      'concurrence.time.7': '7 días',
      'concurrence.time.15': '15 días',
      'concurrence.time.30': '1 mes',
      'concurrence.time.60': '2 meses',
      'concurrence.time.90': '3 meses',
      'concurrence.time.120': '4 meses',
      'concurrence.time.150': '5 meses',
      'concurrence.time.180': '6 meses',
      'concurrence.time.365': '1 año',
      'concurrence.time.9999': 'Sin límite de tiempo',
      'concurrence.time.-1': 'Desactivado',
      'drag-and-drop.item-selected-title': 'Elementos seleccionados',
      'drag-and-drop.item-unselected-title': 'Elementos a seleccionar',
      'dropdown.notificationDeliveryMethod.both': 'Email y push',
      'dropdown.notificationDeliveryMethod.email': 'Email',
      'dropdown.notificationDeliveryMethod.not_notification': 'No notificar',
      'dropdown.notificationDeliveryMethod.push': 'Push',
      'dropdown.unknown': 'Sin especificar',
      'dropdown-with-rule.true': 'Activo',
      'dropdown-with-rule.false': 'Desactivado',
      'dealer.leads.chart.no_dealer': 'Sin instalación',
      'error.aivora.lead_already_prequalified': 'El lead ya fue precualificado anteriormente',
      'error.aivora.empty_contact_phone': 'El lead debe tener un teléfono asociado',
      'error.data_wrong_funnel': 'Los datos no son coherentes con el proceso de cualifcación de leads',
      'error.duplicated_session.body': 'Sesión iniciada en otro dispositivo',
      'error.duplicated_session.title': 'Sesión duplicada',
      'error.duplicated_investment': 'Inversión duplicada',
      'error.email_is_not_valid': 'El email no es válido',
      'error.vat_is_not_valid': 'El NIF/CIF/NIE no es válido',
      'error.found.external_system': 'El lead ya ha sido enviado al sistema externo',
      'error.lead_allready_assigned': 'El lead ya está asignado',
      'error.lead_assigned_another_user': 'El lead está asignado a otro usuario',
      'error.lead_closed': 'El lead está cerrado',
      'error.lead_in_call': 'Lead en llamada',
      'error.lead_must_be_archived_or_on_track': 'El lead debe estar archivado o en seguimiento',
      'error.lead_must_be_new_or_on_track': 'El Lead debe estar en estado nuevo o seguimiento',
      'error.lead_must_have_email': 'El lead debe tener un email asignado.',
      'error.lead_not_status_new': 'El estado del lead no es nuevo',
      'error.not_found.company': 'Empresa no encontrada',
      'error.not_found.external_system': 'Sistema externo no encontrado',
      'error.not_found.lead': 'Lead no encontrado',
      'error.not_found.investment': 'Inversión no encontrada',
      'error.not_reopen_because_already_open.lead': 'El lead ya se encuentra en seguimiento',
      'error.operation_not_allowed': 'Operación no permitida',
      'error.security_control.body': 'Petición no aceptada. Necesita volver a hacer login',
      'error.security_control.title': 'Control de seguridad',
      'error.session_expired.body': 'Su sesión ha expirado, vuelva a hacer login.',
      'error.session_expired.title': 'Sesión expirada',
      'error.thrift_response.integration': 'Error al integrar el lead con el sistema externo',
      'error.user_config_updated.body': 'Su usuario ha sido actualizado. Necesita volver a hacer login',
      'error.user_config_updated.title': 'Usuario actualizado',
      'error.user_has_been_disabled.body': 'El usuario con el que está intentando acceder está desactivado.',
      'error.user_has_been_disabled.title': 'Usuario desactivado',
      'error.user_in_call': 'Usuario en llamada',
      'error.validations.already_in_the_list': 'Ya está en la lista',
      'error.validations.cannot_be_empty': 'Este campo no puede estar vacío',
      'error.validations.date_should_be_major_that_actual': 'La fecha indicada debe ser mayor a la actual.',
      'error.validations.this_field_is_required': 'Este campo es obligatorio',
      'error.fail_comunications_with_woice': 'No se ha podido establecer comunicación con Woice',
      'error.woice_token_not_received': 'Autenticación con Woice fallida',
      'errors.event_no_added': 'Evento no añadido',
      'errors.event_should_date_greater_that_current': 'El evento debe tener una fecha mayor a la actual',
      'filters.company': 'Empresa',
      'filters.contact.filter_by_email': 'E-mail',
      'filters.contact.filter_by_name': 'Nombre',
      'filters.contact.filter_by_phone': 'Teléfono',
      'filters.contact.undefined': 'Nombre / E-mail / Teléfono',
      'filters.error.three_chars_needed.filter_by_email': '* Debe contener al menos 3 caracteres',
      'filters.error.three_chars_needed.filter_by_name': '* Debe contener al menos 3 caracteres',
      'filters.error.three_chars_needed.filter_by_phone': '* Debe contener al menos 3 dígitos',
      'filters.error.three_chars_needed.filter_by_postal_code': '* Debe contener al menos 3 caracteres',
      'filters.error.three_chars_needed.filter_by_province_and_location': '* Debe contener al menos 3 caracteres',
      'filters.error.three_chars_needed.undefined': '* Debe contener al menos 3 caracteres',
      'filters.has_appointment_filter_token': 'Leads con citas',
      'filters.have_filter_selected': 'Hay filtros seleccionados',
      'filters.in_call': 'En llamada',
      'filters.in_prequalification': 'En precualificación',
      'filters.no_report': 'Sin reporte (Cita)',
      'filters.not_come': 'No acude (Cita)',
      'filters.postal_code.filter_by_postal_code': 'Código postal',
      'filters.postal_code.filter_by_province_and_location': 'Provincia / Localidad',
      'filters.postal_code.undefined': 'Código postal / Provincia / Localidad',
      'filters.select_range_of_dates': 'Selecciona rango de fechas',
      'filters.title': 'Filtros',
      'filters.transferred_not_received': 'Transf. no recibido',
      'filters.yes_come': 'Sí acude (Visita)',
      'filters.scoring': 'Scoring',
      'filters.without_scoring': 'Sin scoring',
      'funnel.closed.leads': 'Ventas Cerradas',
      'funnel.contacted.leads': 'Contactados',
      'funnel.total.leads': 'Leads entrantes',
      'funnel.unique.leads': 'Leads únicos',
      'funnel.total_appointments': 'Citas',
      'funnel.visited.leads': 'Visitas',
      'header.new_lead.title': 'Nuevo lead',
      'header.no_selected_company': 'Ninguna empresa seleccionada',
      'header.select_company': 'Selecciona empresa',
      'help.active_business_hours': 'Activa o desactiva el horario laboral en el calendario de eventos',
      'help.active_business_hours_company': 'Configuración del horario comercial de la empresa:' + '<ul>' + '<li>Este horario se tendrá en cuenta para el cálculo del tiempo de respuesta de los usuarios,' + 'midiendo el tiempo transcurrido entre la entrada del lead y el primer intento de contacto.</li>' + '<li>El tiempo comenzará a contar en el instante que se esté dentro de un horario definido hasta el tiempo del primer intento de contacto.</li>' + '<li>La hora de inicio tendrá que ser siempre menor a la hora de fin</li>' + '</ul>',
      'help.assignment_rules.simulator': 'Rellena los campos con la información de un lead de prueba y pulsa en "Simular". Se indicarán los usuarios, que no sean Superadmin, que podrían visualizar dicho lead.',
      'help.assignment_rules_configuration': 'Reglas de asignación',
      'help.assignment-rules.step-1': '¡Bienvenido al asistente de creación de reglas de asignación!' +
        '<p>Con este sistema podrás definir los leads que estarán visibles para cada uno de los usuarios de la herramienta.</p>' +
        '<p>Paso1:</p><ul><li>Identifica esta regla con un nombre, por ejemplo: “usuario – VO Instalación“</li>' +
        '<li>Elige el usuario para el que definir la regla.</li>' +
        '<li>Si tendrá acceso a todos los leads que entren en la herramienta pulsa en “Quiero que lo vea todo”. ' +
        'En caso contrario, comienza su configuración en “Quiero configurar su regla.</li></ul>',
      'help.assignment-rules.step-2': ' Paso 2:<ul><li>Selecciona uno o varios tipos de leads que podrá visualizar el usuario seleccionado.</li></ul>',
      'help.assignment-rules.step-3': ' Paso 3:<ul><li>Selecciona una o varias instalaciones de las que podrá visualizar los leads el usuario seleccionado.</li></ul>',
      'help.assignment-rules.step-4': ' Paso 4:<ul><li>Selecciona uno o varios canales de los que podrá visualizar los leads el usuario seleccionado.</li></ul>',
      'help.assignment-rules.step-5': ' Paso 5:<ul><li>Selecciona una o varias marcas de las que podrá visualizar los leads el usuario seleccionado.</li>',
      'help.assignment-rules.step-6': ' Paso 6:<ul><li>Escribe el/los códigos postales de los que podrá visualizar los leads el usuario seleccionado.</li>' +
      '<li>Marca el checkbox &quot;Añadir rango de códigos postales&quot; para añadir un rango.</li>' +
        '<li>Recuerda pulsar en “Añadir” para incorporarlos a la lista.</li></ul>',
      'help.assignment-rules.step-7': ' Paso 7:<ul><li>Escribe uno o varios campos de Origen de los que podrá visualizar los leads el usuario seleccionado.</li>' +
        '<li>Recuerda pulsar en “Añadir” para incorporarlos a la lista.</li>' +
        '<li>No olvides que el Origen aquí seleccionado tiene que ser exactamente igual al que define el lead.</li></ul>',
      'help.assignment-rules.step-8': ' Paso 8:<ul><li>Al “Finalizar”, la regla quedará activa aplicando toda la configuración seleccionada. En caso de que no deba activarse en este momento, pulsa en “Desactivada”.</li>' +
        '<li>Si todo lo configurado es lo que NO debe ver el usuario, selecciona “Regla negativa”.</li></ul>',
      'help.lead_table_visibility_company': 'Configuración de campos visibles en la tabla de leads:' + '<ul>' + '<li>Puede activar o desactivar los campos que quiera que los usuarios Vendedores visualicen en la tabla para los leads no asignados.</li>' + '<li>Recuerda que "Oculto" significa que no puede ver ese campo en la tabla de leads.</li>' + '</ul>',
      'help.add_day_week': 'Añade un día laboral de la semana a tu horario',
      'help.business_hours_user': 'Configuración del horario laboral del usuario:' + '<ul>' + '<li>Este horario se tendrá en cuenta para resaltar las horas laborales de cada usuario en las agendas de asignación de recordatorios y/o citas.</li>' + '<li>La hora de inicio tendrá que ser siempre menor a la hora de fin.</li>' + '</ul>',
      'help.change_password_required': 'Cambio de contraseña.<br>' + '<ul>' + '<li>Debe contener al menos un número</li>' + '<li>Debe contener al menos una mayúscula</li>' + '<li> Debe contener al menos un carácter especial</li>' + '<li> Debe contener más de 4 caracteres</li>' + '</ul>',
      'help.concurrence': 'Configuración del tiempo de concurrencia del lead para la empresa:' + '<ul>' + '<li>El cálculo para la comprobación de las concurrencias se realizará con la fecha de creación del lead.</li>' + '<li>El rango de tiempo será calculado aplicando ± el tiempo configurado a la fecha de creación del lead.</li>' + '<li>Los meses se consideran como 30 días naturales.</li>' + '<li>El año se considera como 365 días naturales.</li>' + '<li>Ejemplo: [ (-x días).....(F. creación).....(+x días) ]</li>' + '</ul>',
      'help.configure_assignment_method': 'Método de asignación de leads: <br> <ul>' + '<li>Manual' + '<ul>' + '<li>Solo serán notificados de la entrada de nuevos leads los usuarios con rol Administrador y BDC,' + ' siendo estos los encargados del reparto/cualificación del lead.</li>' + '<li>Los usuarios con rol Asesor comercial solo tendrán disponibles los leads que estén asignados a su usuario.</li>' + '</li></ul> ' + '<li>Competitiva' + '<ul>' + '<li>Entrarán en juego las reglas de asignación definida para los usuarios con rol Asesor comercial y ' + 'BDC para notificar la entrada de nuevos leads aquellos usuarios que cumplan las reglas con el lead entrante.</li>' + '<li>En caso de no existir ningún usuario con dicha regla, serán notificados los usuarios con rol Administrador.</li>' + '<li>Los usuarios con rol Asesor comercial tendrán disponibles los leads que estén asignados a su usuario y' + ' además aquellos leads que cumplan con sus reglas de asignación y estén sin asignar.</li>' + '<li>Los usuarios con rol BDC tendrán disponibles los leads que estén asignados a su usuario y' + ' además aquellos leads que cumplan con sus reglas de asignación independientemente del usuario al que esté asignado o sin asignar.</li>' + '</li></ul> ' + '<li>Precualificación Competitiva:' + '<ul>' + '<li>Los leads que entren a DMSVO estarán visibles para los usuarios Admin, Superadmin y BDC. </li>' + '<li>Su llegada se notificará al usuario BDC. </li>' + '<li>El estado inicial de estos leads será “Precualificación”. </li>' + '<li>Los usuarios Vendedores no tendrán en su listado los leads “Precualificación”. Si acceden a ellos a través de la búsqueda avanzada no podrán ver la información de los mismos, ya que su acceso estará bloqueado. </li>' + '<li>Cuando el usuario BDC/Admin o Superadmin gestione el lead, tendrá dos opciones: asignarlo a otro usuario o dejarlo sin asignar. Estos lead pasarán a estado “Nuevo”.</li>' + '<li>En el caso de que el lead esté sin asignar comenzará el sistema competitivo, notificando a los usuarios según las reglas de asignación.</li>' + '</li></ul> ' + '</ul>',
      'help.disabled_no_superadmin': 'Deshabilitado para usuarios administradores. Póngase en contacto con su supervisor o contacte con nosotros.<br><br>',
      'help.configure_timezone': 'Zona horaria de la empresa, la cual influirá en la visualización de los datos de tipo fecha/hora de la empresa,' + ' siendo esta configuración aplicada a todos los usuarios que trabajen en la empresa.',
      'help.tab_change_password': 'Cambio de contraseña.',
      'help.tab_configure_company': 'Configuración general de la empresa.',
      'help.tab_user_settings': 'Configuración del usuario.',
      'help.tracking_email': 'Configuración del seguimiento de email para la empresa: <br> <ul> <li> Que beneficios se obtienen: <ul> <li> Trazabilidad de todas las comunicaciones por email con el lead. </li> <li>'
        + ' Las respuestas del lead son registradas en la bitácora. </li> </ul> </li> <li> Como funciona: <ul> <li> DMSVO genera automáticamente una cuenta de correo para cada usuario. </li> <li> ' +
        'La respuesta a un email es registrada en la bitácora del lead. </li> <li> El usuario es notificado en tiempo real de la llegada de una respuesta de un lead. </li> </ul> </li> </ul>',
      'help.user_account': 'Cuenta de usuario: <br> <ul> <li> Acceso a DMSVO. </li> <li> Recepción de notificaciones vía e-mail. </li> </ul>',
      'help.user_name_surname': 'Nombre y apellidos: <br> <ul> <li> Indica el nombre y apellidos del usuario para mostrar en los selectores. </li>'
        + '<li> Se añade el nombre y apellidos para el envío de e-mail desde la ficha de los leads.</li> </ul>',
      'help.user_phone_number': 'Teléfono: <br> <ul> <li> Almacena el teléfono del usuario a modo informativo. </li>',
      'help.user_language': 'Idioma: <br> <ul> <li> Idioma de la plataforma para el usuario. </li> </ul>',
      'help.user_notifications': 'Notificaciones: <ul> <li> Sistema de notificaciones para que el usuario esté informado de todos los eventos que ocurren como pueden ser: nuevos leads, actualizaciones de un lead, recordatorios de seguimiento, etc.</li>'
        + '<li> Push: Método de notificaciones directas enviadas al dispositivo del usuario donde tiene la sesión activa.</li>'
        + '<li> E-mail: Método de notificaciones por correo electrónico a la cuenta del usuario. </li> </ul>',
      'help.user_sending_email': 'E-mail de envío: <ul> <li> Dirección de correo electrónico para el envío de e-mail a los leads. </li>'
        + '<li>Dirección de correo a la cual se podría responder el leads a un e-mail </li>'
        + '<li>Si la licencia tiene activo el “Seguimiento de e-mail“ las respuestas a los e-mails enviados serán registradas en las bitácoras de la ficha del lead correspondiente </li>'
        + '<li>Si la cuenta de correo es “no-reply” es por que la licencia no tiene activo el “Seguimiento de e-mail”</li> </ul>',
      'help.dropdown-with-rules': 'Activar limitación de desplegables.<ul><li>Al crear o editar un lead, los usuarios Vendedores, solo tendrán disponibles en los desplegables de Canal y Origen, los valores que cumplan las condiciones de sus reglas de asignación. Por ejemplo: si solo puede visualizar leads del Canal Coches.net, ese será el único valor que tendrá en el desplegable Canal al crear o editar leads.</li></ul>',
      'info.coming_soon': 'Próximamente',
      'info.new_content': '¡Nuevo!',
      'lead_archived_type.anotherbrand': 'Otra marca',
      'lead_archived_type.anotherbrand_dealership': 'Otra marca (otro concesionario)',
      'lead_archived_type.by_appraisal': 'Por tasación',
      'lead_archived_type.by_financing': 'Por financiación',
      'lead_archived_type.by_price': 'Por precio',
      'lead_archived_type.contacteds': 'Contactados',
      'lead_archived_type.immature': 'Lead no maduro',
      'lead_archived_type.not_contacted': 'No se pudo contactar',
      'lead_archived_type.not_contacteds': 'No contactados',
      'lead_archived_type.not_interested': 'No interesado',
      'lead_archived_type.other': 'Otros',
      'lead_archived_type.samebrand': 'Misma marca',
      'lead_archived_type.samebrand_dealership': 'Misma marca (otro concesionario)',
      'leadType.': 'Otros',
      'leadType.after_sale': 'Posventa',
      'leadType.commercial': 'Vehículo comercial',
      'leadType.fleet': 'Flotas',
      'leadType.new_vehicle': 'Vehículo nuevo',
      'leadType.used_vehicle': 'Ocasión',
      'leadType.renting': 'Renting',
      'leadType.rent_a_car': 'Rent a Car',
      'leadType.appraisal': 'Tasación',
      'leadType.spare_parts': 'Recambios',
      'leadType.km0': 'Km0',
      'chart.lead_type.': 'Sin clasificar',
      'chart.lead_type.after_sale': 'Posventa',
      'chart.lead_type.commercial': 'Vehículo comercial',
      'chart.lead_type.fleet': 'Flotas',
      'chart.lead_type.new_vehicle': 'Vehículo nuevo',
      'chart.lead_type.used_vehicle': 'Ocasión',
      'chart.lead_type.renting': 'Renting',
      'chart.lead_type.rent_a_car': 'Rent a Car',
      'chart.lead_type.appraisal': 'Tasación',
      'chart.lead_type.spare_parts': 'Recambios',
      'chart.lead_type.km0': 'Km0',
      'legend.filter.archived_leads': 'Leads Archivados',
      'legend.filter.comments': 'Comentarios',
      'legend.filter.contact': 'Contacto',
      'legend.filter.last_lead_modification': 'Última modificación de lead',
      'legend.filter.lead_creation': 'Creación de lead',
      'legend.filter.lead_date_of': 'Fecha de',
      'legend.filter.lead_information': 'Información del lead',
      'legend.filter.on_track_lead': 'Lead en seguimiento',
      'legend.filter.reminder': 'Recordatorio',
      'legend.filter.sold_leads': 'Leads Vendidos',
      'legend.filter.tracings': 'Seguimientos',
      'legend.filter.visit_appointment': 'Cita / Visita',
      'legend.filter.last_modification': 'Última modificación',
      'menu.admin': 'Administración',
      'menu.configuration': 'Configuración',
      'menu.home': 'Inicio',
      'menu.dashboard': 'Panel del control',
      'menu.investment': 'Calculadora de Marketing',
      'menu.leads.title': 'Leads',
      'menu.lead_table_visibility': 'Tabla de leads',
      'menu.login.change.password.title': 'Cambiar Contraseña',
      'menu.login.logout.title': 'Desconectar',
      'menu.login.title': 'Login',
      'menu.metrics.marketing.title': 'Marketing',
      'menu.metrics.sales.title': 'Ventas',
      'menu.metrics.title': 'Métricas',
      'menu.analytics.title': 'Análisis',
      'menu.planning_of_day.title': 'Planificación',
      'menu.quotations.title': 'Presupuestos',
      'menu.reporting.title': 'Reporting',
      'menu.working_hours': 'Horario laboral',
      'metric_lead.appointment_scheduled.title': 'Nº Citas agendadas:',
      'metric_lead.assigned_date.title': 'Última transferencia:',
      'metric_lead.call_start_time.title': 'Inicio de la llamada actual:',
      'metric_lead.created_at.title': 'Entrada del lead:',
      'metric_lead.emails_received.title': 'Nº Email recibidos:',
      'metric_lead.emails_sent.title': 'Nº Email enviados:',
      'metric_lead.end_defeat_date.title': 'Próximo vencimiento:',
      'metric_lead.first_assigned_date.title': 'Primera asignación:',
      'metric_lead.first_call_date.title': 'Primera llamada contestada:',
      'metric_lead.first_contact_bussiness.title': 'Tiempo de respuesta (horario comercial):',
      'metric_lead.first_contact_date.title': 'Primer contacto:',
      'metric_lead.first_contact_user.name': 'Usuario que realiza el primer contacto:',
      'metric_lead.first_interaction_date.title': 'Primera interacción:',
      'metric_lead.first_user_assigned.title': 'Primer usuario asignado:',
      'metric_lead.real_response_time.title': 'Tiempo de respuesta (real):',
      'metric_lead.reminders_scheduled.title': 'Nº Recordatorios agendados:',
      'metric_lead.times_edited.title': 'Nº veces editado:',
      'metric_lead.times_transferred.title': 'Nº veces transferido:',
      'metric_lead.times_with_call_response.title': 'Nº llamadas respondidas:',
      'metric_lead.times_without_call_response.title': 'Nº llamadas no respondidas:',
      'metric_lead.total_interactions.title': 'Total de interacciones:',
      'metric_lead.transferred.title': 'Pendiente recibir transferencia:',
      'metric_lead.updated_at.title': 'Última modificación:',
      'metric_lead.whatsapps_sent.title': 'Nº Whastapp enviados:',
      'metrics.marketing.channel.leads.table.channel.undefined': 'Sin específicar',
      'metrics.marketing.channel.leads.table.head.channel': 'Canal',
      'metrics.marketing.channel.leads.table.head.closed': 'Ventas',
      'metrics.marketing.channel.leads.table.head.contacted': 'Contactados',
      'metrics.marketing.channel.leads.table.head.leads': 'Leads',
      'metrics.marketing.channel.leads.table.head.onTrack': 'En Seguimiento',
      'metrics.marketing.channel.leads.table.head.total': 'TOTAL',
      'metrics.marketing.channel.leads.table.head.totalAppointments': 'Citas',
      'metrics.marketing.channel.leads.table.head.visited': 'Visitas',
      'modal.body.date.notification_received': 'Notificación recibida el:',
      'modal.response.add.receiver.lead': 'Añadirme como destinatario "Cc"',
      'modal.response.notification.lead': 'Responder con la notificación que creó el lead',
      'modal.response.notification.lead_generated': 'Se añadirá al final del email la notificación de correo electrónico que generó este lead en DMSVO',
      'modal.subject.response': 'RE:',
      'modals.add_postal_code.button': 'Añadir código postal',
      'modals.add_postal_code.range': 'Añadir rango de códigos postales',
      'modals.add_origin.button': 'Añadir Origen',
      'modals.appointment.this_lead_already_has_a_appointment': 'Este lead ya tiene una cita programada',
      'modals.appointment.title': 'Cita',
      'modals.archive.archived_option.required': 'Seleccione una opción',
      'modals.archive.comments.required': 'Comentario obligatorio',
      'modals.archived_lead.title': 'Archivar Lead',
      'modals.are.you.sure.delete.this.lead': '¿Está seguro de que quiere eliminar este lead?',
      'modals.assign.button': 'Asignar',
      'modals.assign.leads.title': 'Asignar Leads',
      'modals.calendar.transfer_to_another_user': 'El lead se va a transferir a un usuario diferente al actual, ¿está seguro?',
      'modals.call.finish_call_form.comments.required': 'Comentario obligatorio',
      'modals.call.finish_call_form.on_track_status.required': 'Seleccione una opción',
      'modals.call.title': 'Resultado de la interacción',
      'modals.call.visit_confirmation_form.attended': 'Acude a la cita',
      'modals.call.visit_confirmation_form.date_result': 'Resultado de la cita del',
      'modals.call.visit_confirmation_form.not_attended': 'No acude a la cita',
      'modals.cancel.button': 'Cancelar',
      'modals.close.button': 'Cerrar',
      'modals.close.choose_when': 'Fecha de venta:',
      'modals.close.comments.required': 'Comentario obligatorio',
      'modals.close.select_date': 'Seleccione una fecha:',
      'modals.close_sale.title': 'Cerrar venta',
      'modals.configure_rules.button': 'Quiero configurar su regla',
      'modals.comment.add_comment': 'Añadir comentario',
      'modals.complete_name': 'Nombre y apellidos',
      'modals.delete.button': 'Eliminar',
      'modals.delete.comments.required': 'Comentario obligatorio',
      'modals.delete.leads.title': '¿Está seguro?',
      'modals.massive_edit.leads.title': 'Edición masiva de leads',
      'modals.massive_edit.leads.message1': 'Se aplicará el cambio a todos los leads seleccionados.',
      'modals.massive_edit.leads.message2': 'La informacion añadida editará el origen del lead.',
      'modals.edit.button': 'Editar',
      'modals.edit.lead.title': 'Editar Lead',
      'modals.import.title': 'Importar leads desde fichero CSV',
      'modals.importer.brand_not_found': 'No se ha encontrado la marca',
      'modals.importer.button': 'Importar',
      'modals.importer.toast.success': 'Importación correcta',
      'modals.importer.toast.success.info': 'Los leads se han importado correctamente',
      'modals.importer.toast.error': 'Error al importar',
      'modals.importer.toast.error.info': 'Ha ocurrido un error al importar los lead',
      'modals.importer.channel_not_found': 'No se ha encontrado el canal',
      'modals.importer.check_fields': 'Validando campos',
      'modals.importer.check_dates': 'Validando Fechas',
      'modals.importer.columns_is_not_correct': 'No contiene las columnas correctas',
      'modals.importer.creating_new_leads': 'Creando nuevos leads',
      'modals.importer.dealer_not_found': 'No se ha encontrado la instalación',
      'modals.importer.user_not_found': 'No se ha encontrado el usuario',
      'modals.importer.id_duplicated': 'El campo ID esta duplicado',
      'modals.importer.name_is_required': 'Nombre y apellidos son campos requeridos',
      'modals.importer.email_phone_is_required': 'Email/Teléfono son campos requeridos',
      'modals.importer.comment_max_size': 'El comentario no puede tener mas de 200000 carácteres',
      'modals.importer.status_is_required': 'Estado es un campo requerido',
      'modals.importer.user_is_required': 'Usuario es un campo requerido',
      'modals.importer.status_invalid_option': 'El campo estado debe incluir uno de los siguientes valores: Nuevo Lead, En seguimiento, Archivado, Venta cerrada',
      'modals.importer.created_date_required': 'El campo Fecha de creación tiene que estar relleno',
      'modals.importer.date_less_now': 'El campo Fecha no puede ser mayor a la fecha actual',
      'modals.importer.date_less_created': 'El campo Fecha no puede ser menor a la fecha de creación',
      'modals.importer.date_less_ontrack': 'El campo Fecha no puede ser menor a la fecha de seguimiento',
      'modals.importer.temp_required': 'El campo Temperatura tiene que estar relleno',
      'modals.importer.temp_invalid_option': 'El campo temperatura debe incluir uno de los siguientes valores: Tibio, Frío o Caliente',
      'modals.importer.archived_date_required': 'El campo Fecha de archivado tiene que estar relleno',
      'modals.importer.archived_type_required': 'El campo Motivo de archivado tiene que estar relleno',
      'modals.importer.on_track_date_required': 'El campo Fecha de seguimiento tiene que estar relleno',
      'modals.importer.close_date_required': 'El campo Fecha de venta tiene que estar relleno',
      'modals.importer.date_incorrect_format': 'El campo Fecha tiene un formato incorrecto recuerda que los formatos admitidos son: 21/6/2021 15:13:21,  21/06/2021 15:13:21, 21/6/2021 o 21/06/2021',
      'modals.importer.archived_type_incorrect': 'El campo Motivo de archivado permite los siguientes valores No se pudo contactar, No interesado, Otros, Por precio, Por financiación, Por tasacion, Lead no maduro, Misma marca, Misma marca (otro concesionario), Otra marca, Otra marca (otro concesionario)',
      'modals.importer.id_is_required': 'ID es un campo requerido',
      'modals.importer.id_is_duplicated': 'ID no puede estar repetido',
      'modals.importer.invalid_plate': 'El formato de la matrícula no es correcto',
      'modals.importer.invalid_vat': 'Valor no válido',
      'modals.importer.file': 'Fichero',
      'modals.importer.headers.file_line': 'Línea fichero',
      'modals.importer.headers.message': 'Mensaje',
      'modals.importer.headers.name': 'Nombre',
      'modals.importer.headers.number_lead': 'Lead Nº',
      'modals.importer.instructions.codification': 'La codificación UTF-8',
      'modals.importer.instructions.delimiter_quotes': 'Delimitador de texto las comillas dobles ".',
      'modals.importer.instructions.format_should_csv': 'Formato .csv',
      'modals.importer.instructions.header': 'Importar fichero (csv)',
      'modals.importer.instructions.headers_valids': ' No se tendrá en cuenta la primera fila de cabeceras,' + ' pero sí deben cumplir el orden de las columnas. Puede descargar una plantilla ',
      'modals.importer.instructions.headers_valids_here': 'aquí',
      'modals.importer.instructions.info_channel': 'La información del Canal / Marca / Tipo / Instalación / Temperatura / Motivo Archivado debe ser igual' + ' a la que se visualiza en los desplegables de los filtros.',
      'modals.importer.instructions.postal_code': 'La información del Código Postal (CP) tiene que ser sólo los dígitos del código.',
      'modals.importer.instructions.dates': 'Formatos compatibles para fechas: 21/6/2021 15:13:21, 21/06/2021 15:13:21, 21/6/2021 ó 21/06/2021',
      'modals.importer.instructions.id': 'La información del ID es obligatoria y tiene que ser único por cada fila.',
      'modals.importer.instructions.status': 'Campos obligatorios:',
      'modals.importer.instructions.statusv2': 'Estado, dependiendo del valor indicado, además será obligatorio:',
      'modals.importer.instructions.new_lead': 'Valor "Nuevo Lead": ningún campo adicional obligatorio.',
      'modals.importer.instructions.name': 'Nombre y apellidos.',
      'modals.importer.instructions.email': 'Teléfono o e-mail.',
      'modals.importer.instructions.new_lead_info': 'No es obligatorio el resto de campos consecutivos por cada fila.',
      'modals.importer.instructions.on_track': 'Valor "En seguimiento": obligatorio rellenar "Fecha Creación", "Fecha Seguimiento" y “Temperatura”.',
      'modals.importer.instructions.on_track_info': 'Campo obligatorio relleno "Fecha Creación" y "Fecha Seguimiento".',
      'modals.importer.instructions.close': 'Valor "Venta cerrada": obligatorio rellenar "Fecha Creación", "Fecha Seguimiento", "Fecha Venta Cerrada" y “Temperatura”.',
      'modals.importer.instructions.close_info': 'Campo obligatorio relleno "Fecha Creación" y "Fecha Venta Cerrada".',
      'modals.importer.instructions.archive': 'Valor "Archivado": obligatorio rellenar "Fecha Creación", "Fecha Archivado" y “Motivo Archivado”.',
      'modals.importer.instructions.archive_info': 'Campo obligatorio relleno "Fecha Creación" y "Fecha Venta Cerrada".',
      'modals.importer.instructions.plate': 'Formatos compatibles para Matrícula: "1111XXX, X1111X, XX111111, XX1111XX, 1XXXX11, X1111XXX".',
      'modals.importer.instructions.vat': 'Formatos válidos para NIF/CIF/NIE: España',
      'modals.importer.instructions.user': 'Usuario: excepto para el estado "Nuevo Lead".',
      'modals.importer.instructions.separator_fields': 'Separador de campos punto y coma ";".',
      'modals.importer.id_is_a_required_field': 'El nombre y apellidos es campo obligatorio.',
      'modals.importer.phone_invalid': 'Teléfono inválido',
      'modals.importer.preparing_new_leads': 'Preparando leads',
      'modals.importer.validating_brands': 'Validando marcas',
      'modals.importer.validating_channels': 'Validando canales',
      'modals.importer.validating_dealers': 'Validando instalaciones',
      'modals.importer.validating_users': 'Validando usuarios',
      'modals.importer.validating_ids': 'Validando Ids',
      'modals.importer.validating_headers': 'Validando cabeceras',
      'modals.importer.validating_lead_columns': 'Validando columnas',
      'modals.importer.validating_types': 'Validando tipos',
      'modals.investment_edit.title': 'Edición de la inversión',
      'modals.investment_new.title': 'Nueva Campaña (Origen)',
      'modals.investment.campaign': 'Campaña (origen)',
      'modals.investment.amount': 'Inversión',
      'modals.investment.channel': 'Canal',
      'modals.leadin_live.copied_link': 'Copiar enlace',
      'modals.leadin_live.copied_message': '¡Copiado!',
      'modals.leadin_live.copy_button': 'Copiar',
      'modals.leadin_live.expiration_advice': 'Tenga en cuenta que el enlace caducará transcurrido 1 hora',
      'modals.leadin_live.header': 'DMSVO Live',
      'modals.leadin_live.leadin_live_info': '<p>¿Aún no tienes activado <b>DMSVO Live</b>? Contacta con nuestros equipo para activar esta nueva funcionalidad.</p>' + '<p><b>DMSVO Live</b> es un sistema de videollamada completamente integrado dentro de DMSVO.</p>' + '<p>Con <b>DMSVO Live</b> podrás realizar visitas a través de videollamada para poder enseñar los vehículos que tus leads buscan. Además, podrás compartir tu pantalla del ordenador para mostrarle todo lo que necesites para ayudarte con la venta.</p>',
      'modals.leadin_live.request_subscription': 'Solicita el alta',
      'modals.leadin_live.room_access': 'Acceder a la sala de DMSVO Live',
      'modals.leadin_live.select_channel': 'Seleccione el canal por el que desea enviar al cliente el enlace para iniciar videollamada.',
      'modals.leadin_live.select_channel_to_invite_one': 'Seleccione el canal por el que desea enviar al cliente el enlace para iniciar videollamada.',
      'modals.leadin_live.select_channel_to_invite_two': 'Tenga en cuenta que el enlace caducará transcurrido 1 hora',
      'modals.leadin_live.send_invitation': 'Enviar invitación',
      'modals.leadin_live.send_link_to_invite': 'Enviar enlace para iniciar videollamada',
      'modals.leadin_live.subheader': 'Un paso más en la gestión de leads',
      'modals.new.lead.title': 'Nuevo Lead',
      'modals.new_to_ontrack.title': 'Pasar lead a "En seguimiento"',
      'modals.new.rule.button': 'Nueva regla',
      'modals.next.button': 'Siguiente',
      'modals.next_steps': 'Próximo paso',
      'modals.finish': 'Finalizar',
      'modals.on_track.comments.required': 'Comentario obligatorio',
      'modals.on_track.on_track_status.required': 'Seleccione una opción',
      'modals.on_track.title': 'Interacción',
      'modals.previous.button': 'Anterior',
      'modals.reminder.this_lead_already_has_a_reminder': 'Este lead ya tiene un recordatorio',
      'modals.reminder.title': 'Recordatorio',
      'modals.retry_import.button': 'Volver a cargar fichero',
      'modals.revert.close.cancel': 'Cancelar la venta',
      'modals.revert.close_sale.title': 'Revertir venta cerrada',
      'modals.save.button': 'Guardar',
      'modals.select_user_to_assign_lead': 'Selecciona a un usuario al que asignar los leads:',
      'modals.select_user_to_transfer_lead': 'Selecciona a un usuario al que transferir los leads:',
      'modals.see_everything.button': 'Quiero que lo vea todo',
      'modals.simulate.lead.button': 'Simular',
      'modals.simulate.lead.email': 'test@test.test',
      'modals.simulate.lead.model': 'Modelo test',
      'modals.simulate.lead.phone': '910000000',
      'modals.simulate.lead.title': 'Simulación de un Lead',
      'modals.selected.origins': 'Orígenes seleccionados',
      'modals.selected.postal_codes': 'Códigos postales seleccionados',
      'modals.send.button': 'Enviar',
      'modals.send_mail.body.required': 'Cuerpo del mensaje obligatorio',
      'modals.send_mail.subject': 'Asunto',
      'modals.send_mail.subject.required': 'Asunto obligatorio',
      'modals.send_mail.title': 'Envío de email',
      'modals.send_mail.write_your_email': 'Redacte su email',
      'modals.send_whats_app.comments.required': 'Comentario obligatorio',
      'modals.send_whatsapp_invitation.body': 'Hola REPLACE_THIS le ha enviado un enlace para unirse a una vídeo llamada. Pulse sobre el siguiente enlace para acceder.',
      'modals.send_whatsapp.title': 'Enviar WhatsApp',
      'modals.send_whatsapp.write_your_whatsapp': 'Redacte su mensaje: ',
      'modals.title.postal_code': 'Código postal',
      'modals.title.address': 'Dirección',
      'modals.transfer.button': 'Transferir',
      'modals.transfer_leads_title': 'Transferir leads.',
      'page.mylead.no_especificado': 'No especificado',
      'pages.configuration.concurrences': 'Concurrencias',
      'pages.create.assignment-rule.title': 'Asistente de creación de reglas',
      'pages.create.assignment-rule.step_1': 'Paso 1',
      'pages.create.assignment-rule.step_2': 'Paso 2',
      'pages.create.assignment-rule.step_3': 'Paso 3',
      'pages.create.assignment-rule.step_4': 'Paso 4',
      'pages.create.assignment-rule.step_5': 'Paso 5',
      'pages.create.assignment-rule.step_6': 'Paso 6',
      'pages.create.assignment-rule.step_7': 'Paso 7',
      'pages.create.assignment-rule.step_8': 'Paso 8',
      'pages.create.assignment-rule.step_1.description': 'Nombre y usuario',
      'pages.create.assignment-rule.step_1.description_1': 'Nombre de la regla',
      'pages.create.assignment-rule.step_1.description_2': 'Usuario',
      'pages.create.assignment-rule.step_1.description_3': '¿A qué tendrá acceso este usuario?',
      'pages.create.assignment-rule.step_2.description': 'Tipos de leads',
      'pages.create.assignment-rule.step_3.description': 'Instalaciones',
      'pages.create.assignment-rule.step_4.description': 'Canales',
      'pages.create.assignment-rule.step_5.description': 'Marcas',
      'pages.create.assignment-rule.step_6.description': 'Códigos postales',
      'pages.create.assignment-rule.step_7.description': 'Orígenes',
      'pages.create.assignment-rule.step_8.description': 'Activación',
      'pages.create.assignment-rule.users_unselected': 'Usuarios sin seleccionar',
      'pages.create.assignment-rule.users_selected': 'Usuarios seleccionados',
      'pages.dashboard-bdc.assigned': 'Leads asignados',
      'pages.dashboard-bdc.expired_on_track_leads': 'Leads vencidos',
      'pages.dashboard-bdc.no_track_leads': 'Leads sin seguimiento',
      'pages.dashboard-bdc.on_track_leads': 'Leads con seguimiento',
      'pages.dashboard-bdc.unnasignedLeads': 'Leads sin asignar',
      'pages.dropdown-with-rules.title': 'Limitar desplegables',
      'pages.historic.at': 'a las',
      'pages.historic.duration_interaction': 'Duración de la interacción',
      'pages.historic.for_the_day': ' para el día ',
      'pages.historic.hidden_mail': 'Ocultar email',
      'pages.historic.hidden_whatsapp': 'Ocultar whatsapp',
      'pages.historic.inboud_leads': 'Entrada de lead',
      'pages.historic.lead_assigned_to': 'Lead asignado a',
      'pages.historic.lead_sold_on': 'Lead vendido el:',
      'pages.historic.lead_transfered_to': 'Lead transferido a',
      'pages.historic.not_contacted': 'No contactado',
      'pages.historic.scheduled_appointment': 'Cita agendada',
      'pages.historic.show_mail': 'Ver email',
      'pages.historic.show_whatsapp': 'Ver whatsapp',
      'pages.historic.status_label': 'Lead etiquetado',
      'pages.historic.visit_attended': 'Visita realizada con éxito',
      'pages.historic.visit_not_attended': 'Visita no realizada',
      'pages.investment.tab.configuration': 'Configuración',
      'pages.investment.tab.configuration.new.label': 'Nueva Campaña (origen)',
      'pages.investment.tab.configuration.channel.label': 'Canal',
      'pages.investment.tab.configuration.campaign.label': 'Campaña (origen)',
      'pages.investment.tab.configuration.investment.label': 'Inversión',
      'pages.investment.tab.configuration.updated_at.label': 'Modificación',
      'pages.investment.tab.data': 'Datos',
      'pages.investment.tab.data.campaign.label': 'Campaña (origen)',
      'pages.investment.tab.data.investment.label': 'Inversión (€)',
      'pages.investment.tab.data.lead_cost.label': 'Coste por lead',
      'pages.investment.tab.data.visit_cost.label': 'Coste por visita',
      'pages.investment.tab.data.sale_cost.label': 'Coste por venta',
      'pages.investment.tab.filter.channel': 'Canal',
      'pages.investment.tab.filter.campaign': 'Campaña (origen)',
      'pages.leadin_live.subtitle': 'Espere un momento, por favor.',
      'pages.leadin_live.title': 'Redirigiendo a DMSVO Live',
      'pages.leads.actions': 'Acciones',
      'pages.leads.address': 'Dirección',
      'pages.leads.apply': 'Aplicar',
      'pages.leads.appointment': 'Cita',
      'pages.leads.appointments': 'Citas',
      'pages.leads.archive': 'Archivar',
      'pages.leads.assign': 'Asignar',
      'pages.leads.assigned': 'Asignado',
      'pages.leads.assigned_to': 'Asignado a',
      'pages.leads.bemycar_update': 'Integrado con Bemycar',
      'pages.leads.woice_update': 'Integrado con Woice',
      'pages.leads.brand': 'Marca',
      'pages.leads.brands': 'Marcas',
      'pages.leads.browse_files': 'Examinar archivos',
      'pages.leads.calendar': 'Calendario',
      'pages.leads.channel': 'Canal',
      'pages.leads.channels': 'Canales',
      'pages.leads.comments': 'Comentario',
      'pages.leads.contacteds': 'Contactados',
      'pages.leads.created_at': 'Entrada',
      'pages.leads.created_at_special': 'Entrada',
      'pages.leads.custom_filter.advise': 'Uno de los filtros customizados está activo, quitelo para para poder utilizar este filtro',
      'pages.leads.date_of': 'Fecha de ',
      'pages.leads.date_of_special': 'Fecha de ',
      'pages.leads.day': 'día',
      'pages.leads.days': 'días',
      'pages.leads.dealer': 'Instalación',
      'pages.leads.dealers': 'Instalaciones',
      'pages.leads.delete': 'Borrar',
      'pages.leads.description': 'Descripción',
      'pages.leads.description_model': 'Modelo de interés',
      'pages.leads.drop_file_here': 'Suelte el archivo aqui',
      'pages.leads.edit': 'Editar',
      'pages.leads.email': 'E-mail',
      'pages.leads.vat': 'NIF',
      'pages.leads.from': 'Desde',
      'pages.leads.has_comment': 'Tiene comentario',
      'pages.leads.has_email': 'Tiene email',
      'pages.leads.has_phone': 'Tiene teléfono',
      'pages.leads.hour': 'hora',
      'pages.leads.hours': 'horas',
      'pages.leads.import.error.headers': 'Las cabeceras del fichero csv no son correctas.',
      'pages.leads.import.error.type_not_found': 'El tipo indicado no es válido. Valores admitidos V.N / V.O / Posventa / Vacío',
      'pages.leads.lead': 'Lead',
      'pages.leads.leads': 'Leads',
      'pages.leads.leads_per_page': 'Leads por página',
      'pages.rules.leads_per_page': 'Reglas por página',
      'pages.leads.location': 'Localidad',
      'pages.leads.model': 'Modelo',
      'pages.leads.scoring': 'Scoring',
      'pages.leads.plate': 'Matrícula',
      'pages.leads.tag': 'Tags',
      'pages.leads.month': 'Mes',
      'pages.leads.months': 'Meses',
      'pages.leads.motive_of_cancelation': 'Motive aquí la cancelación de esta venta',
      'pages.leads.name': 'Nombre',
      'pages.leads.new': 'Nuevo',
      'pages.leads.news': 'Nuevos',
      'pages.leads.open': 'Abiertos',
      'pages.leads.origin': 'Origen',
      'pages.leads.others_f': 'Otras',
      'pages.leads.pending': 'Vencidos',
      'pages.leads.phone': 'Teléfono',
      'pages.leads.postal_code': 'Código postal',
      'pages.leads.province_and_location': 'Provincia / Localidad',
      'pages.leads.put_your_comment': 'Deje aquí su comentario',
      'pages.leads.reminder': 'Recordatorio',
      'pages.leads.reminders': 'Recordatorios',
      'pages.leads.reopen': 'Reabrir',
      'pages.leads.reset_filter': 'Limpiar filtros',
      'pages.leads.search': 'Buscar',
      'pages.leads.select_all': 'Seleccionar todo',
      'pages.leads.select_element': 'Seleccione un elemento',
      'pages.leads.select_element.error': 'Seleccione al menos un elemento',
      'pages.leads.select_option': 'Seleccione una opción',
      'pages.leads.status': 'Estado',
      'pages.leads.status.archived': 'Archivado',
      'pages.leads.status.closed': 'Venta cerrada',
      'pages.leads.status.cold': 'Frío',
      'pages.leads.status.hot': 'Caliente',
      'pages.leads.status.new': 'Nuevo Lead',
      'pages.leads.status.new_message': 'Nuevo mensaje',
      'pages.leads.status.on_track': 'En seguimiento',
      'pages.leads.status.type.buyed': 'Ya compró',
      'pages.leads.status.type.notbuyed': 'No compra',
      'pages.leads.status.type.prequalification': 'Precualificación',
      'pages.leads.status.warm': 'Tibio',
      'pages.leads.tags.24h': '24h',
      'pages.leads.tags.48h': '48h',
      'pages.leads.tags.defeated': 'Vencido',
      'pages.leads.tags.expiration': 'Vencimiento',
      'pages.leads.tags.new': 'Nuevo',
      'pages.leads.tags.today': 'Hoy',
      'pages.leads.tags.prequalification': 'Precualificación',
      'pages.leads.to': 'Hasta',
      'pages.leads.today': 'Hoy',
      'pages.leads.tomorrow': 'Mañana',
      'pages.leads.transfer': 'Transferir',
      'pages.leads.transfereds': 'Transferidos',
      'pages.leads.type': 'Tipo',
      'pages.leads.type.': 'Sin especificar',
      'pages.leads.type.after_sale': 'Posventa',
      'pages.leads.type.commercial': 'Vehículos comerciales',
      'pages.leads.type.fleet': 'Flotas',
      'pages.leads.type.new_vehicle': 'V.N.',
      'pages.leads.type.rent_a_car': 'Rent a Car',
      'pages.leads.type.renting': 'Renting',
      'pages.leads.type.appraisal': 'Tasación',
      'pages.leads.type.spare_parts': 'Recambios',
      'pages.leads.type.km0': 'Km0',
      'pages.leads.type.unknow': 'Sin especificar',
      'pages.leads.type.used_vehicle': 'V.O.',
      'pages.leads.unselect_all': 'Deseleccionar todo',
      'pages.leads.updated_at': 'Modificación',
      'pages.leads.user': 'Usuario',
      'pages.leads.users': 'Usuarios',
      'pages.leads.visit': 'Cita',
      'pages.leads.yesterday': 'Ayer',
      'pages.leads.no_potencial_sellers': 'Leads NO accesibles por los asesores',
      'pages.leads.potencial_sellers': 'Usuarios que pueden gestionar el lead',
      'pages.leads.accessible_lead': 'Leads accesibles por:',
      'pages.leads.quotation.loading': 'Cargando',
      'pages.leads.quotation.vehicle': 'Vehículo',
      'pages.leads.quotation.amount': 'Importe',
      'pages.leads.quotation.status': 'Estado',
      'pages.leads.quotation.creationDate': 'Creación',
      'pages.leads.quotation.dates': 'Fechas',
      'pages.leads.quotation.modificationDate': 'Última actualización',
      'pages.leads.quotation.quotationCreation': 'Crear presupuesto',
      'pages.leads.quotation.quotationModification': 'Modificar presupuesto',
      'pages.leads.quotation.contractDate': 'Fecha de contrato',
      'pages.leads.quotation.saleDate': 'Fecha de venta',      
      'pages.leads.quotation.quotationSoldClosingComment': 'Lead cerrado por venta',
      'pages.marketing.contacted': 'Contactados',
      'pages.marketing.conversion_indicators': 'Indicadores de conversión',
      'pages.marketing.inboud_leads_per_channels': 'Entrada de Leads por canal/hora',
      'pages.marketing.inboud_leads_per_channels_day_week': 'Entrada de Leads por canal/día',
      'pages.marketing.leads': 'Leads',
      'pages.marketing.on_track': 'En seguimiento',
      'pages.marketing.sales': 'Ventas',
      'pages.marketing.totalAppointments': 'Citas',
      'pages.marketing.visited': 'Visitas',
      'pages.metrics.sales.archived.leads': 'Archivados',
      'pages.metrics.sales.closed.leads': 'Ventas',
      'pages.metrics.sales.contacted.leads': 'Contactados',
      'pages.metrics.sales.interactions.count': 'Nº Interacciones',
      'pages.metrics.sales.interactions.total': 'TOTAL',
      'pages.metrics.sales.leads': 'Leads',
      'pages.metrics.sales.uniques': 'Únicos',
      'pages.metrics.sales.min.leads': 'Min/Lead',
      'pages.metrics.sales.onTrack.leads': 'En Seguimiento',
      'pages.metrics.sales.salesman': 'Vendedor',
      'pages.metrics.sales.salesman.unnasigned': 'Sin asignar',
      'pages.metrics.sales.salesmen': 'Vendedores',
      'pages.metrics.sales.closing_ratio': 'Lead únicos vendidos',
      'pages.metrics.sales.totalAppointments': 'Citas',
      'pages.metrics.sales.visited.leads': 'Visitas',
      'pages.metrics.sales.closed_ratio.title': 'Ratio de cierre por cliente único',
      'pages.metrics.sales.closed_ratio.info': '* El periodo máximo para filtrar por “Creación de lead” es de un año, desde la fecha de hoy. Este filtro se aplica por defecto.',
      'pages.mylead.add_comment': 'Añadir comentario',
      'pages.mylead.add_event': 'Añadir evento',
      'pages.mylead.appointment_remove': 'Cita eliminada',
      'pages.mylead.details.after_sale': 'Posventa',
      'pages.mylead.details.commercial': 'Vehículo comercial',
      'pages.mylead.details.createdat': 'Entró',
      'pages.mylead.details.fleet': 'Flotas',
      'pages.mylead.details.new_vehicle': 'Vehículo nuevo',
      'pages.mylead.details.renting': 'Renting',
      'pages.mylead.details.appraisal': 'Tasación',
      'pages.mylead.details.spare_parts': 'Recambios',
      'pages.mylead.details.km0': 'Km0',
      'pages.mylead.details.unknow': 'Sin especificar',
      'pages.mylead.details.unnasigned': 'Sin asignar',
      'pages.mylead.details.used_vehicle': 'Vehículo Usado',
      'pages.mylead.details.rent_a_car': 'Rent a Car',
      'pages.mylead.exclusive.lead': 'Lead asignado a: ',
      'pages.mylead.remove': 'eliminado',
      'pages.mylead.interested_leads': 'Leads interesados:',
      'pages.mylead.tab.concurrences': 'Coincidencias',
      'pages.mylead.tab.quotations': 'Presupuestos',
      'pages.mylead.tab.crm': 'Compartir',
      'pages.mylead.tab.crm.apply': 'Enviar lead',
      'pages.mylead.tab.crm.external_integration': 'Seleccione un sistema externo',
      'pages.mylead.tab.crm.external_integration_name': 'Destino',
      'pages.mylead.tab.crm.new_external_systems': 'También puedes solicitar nuevas integraciones.',
      'pages.mylead.tab.crm.no_external_systems': 'No hay configurado ningún sistema externo; actualmente las integraciones disponibles para configurar son:',
      'pages.mylead.tab.crm.no_external_systems_help': 'Si necesitas configurar algún sistema externo ponte en contacto con nosotros ',
      'pages.mylead.tab.crm.shipping': 'Envío',
      'pages.mylead.tab.crm.user': 'Usuario',
      'pages.mylead.tab.events': 'Eventos',
      'pages.mylead.tab.historic': 'Historial',
      'pages.mylead.tab.interaction': 'Llamada en curso',
      'pages.mylead.tab.lead': 'Lead',
      'pages.mylead.tab.metric': 'Detalle',
      'pages.mylead.tab.schedule': 'Eventos',
      'pages.notice.url.show_more': 'Más información',
      'pages.profile.activate_business_hours': 'Activar horario laboral',
      'pages.profile.activate_lead_table_visibility': 'Ocultar información tabla de leads',
      'pages.profile.activate_lead_table_visibility_visible': 'Visible',
      'pages.profile.activate_lead_table_visibility_no_visible': 'Oculto',
      'pages.profile.email': 'E-mail',
      'pages.profile.language': 'Idioma',
      'pages.profile.language.en': 'Inglés',
      'pages.profile.language.es': 'Español',
      'pages.profile.language.fr': 'Francés',
      'pages.profile.language.pt': 'Portugués',
      'pages.profile.lastname': 'Apellidos',
      'pages.profile.name': 'Nombre',
      'pages.profile.phone_number': 'Teléfono',
      'pages.profile.notification': 'Notificaciones',
      'pages.profile.notification.placeholder': 'Selecciona como notificar leads',
      'pages.profile.positive_rules': 'Regla Positiva',
      'pages.profile.rules.positive_rules': 'Regla Positiva',
      'pages.profile.rules.active': 'Activa',
      'pages.profile.timezone': 'Zona horaria',
      'pages.profile.workingday.0': 'Domingo',
      'pages.profile.workingday.1': 'Lunes',
      'pages.profile.workingday.2': 'Martes',
      'pages.profile.workingday.3': 'Miércoles',
      'pages.profile.workingday.4': 'Jueves',
      'pages.profile.workingday.5': 'Viernes',
      'pages.profile.workingday.6': 'Sábado',
      'pages.profile.workingday.short.0': 'D',
      'pages.profile.workingday.short.1': 'L',
      'pages.profile.workingday.short.2': 'M',
      'pages.profile.workingday.short.3': 'X',
      'pages.profile.workingday.short.4': 'J',
      'pages.profile.workingday.short.5': 'V',
      'pages.profile.workingday.short.6': 'S',
      'pages.profile.sending_email': 'E-mail de envío',
      'pages.profile.user_account': 'Cuenta de usuario',
      'pages.reporting.bdc.bdctimes': 'Reporte de leads gestionados por usuarios con rol BDC',
      'pages.reporting.download': 'Descargar',
      'pages.reporting.tabtitle.bdc': 'BDC',
      'pages.reporting.tabtitle.leads': 'Leads',
      'pages.reporting.tabtitle.marketing': 'Marketing',
      'pages.reporting.tabtitle.sales': 'Ventas',
      'pages.sales.sales_funnel': 'Embudo de ventas',
      'pages.sales.sales_funnel.archived': 'Archivado',
      'pages.sales.sales_funnel.on_track': 'En seguimiento',
      'pages.sales.time_reports': 'Tiempo de respuesta de Leads',
      'pages.sales.time_reports_by_user': 'Tiempo de respuesta de Leads por usuario',
      'pages.schedule.events_to_manage': 'Tienes eventos que gestionar antes',
      'pages.schedule.no_future_events': 'No hay eventos futuros',
      'pages.security.change_password.button_change_password': 'Cambiar contraseña',
      'pages.security.change_password.confirm_password_placeholder': 'Confirmación',
      'pages.security.change_password.confirm_password_validation_required': 'Confirmación de contraseña obligatoria',
      'pages.security.change_password.modals.error.body': 'Por favor compruebe sus credenciales',
      'pages.security.change_password.modals.error.title': 'Error al cambiar contraseña',
      'pages.security.change_password.modals.success.body': 'Por favor inicie sesión con su nueva contraseña',
      'pages.security.change_password.modals.success.title': 'Cambio de contraseña realizado con éxito',
      'pages.security.change_password.password_placeholder': 'Nueva contraseña',
      'pages.security.change_password.password_validation_capital_case': 'Debe contener al menos una mayuscula',
      'pages.security.change_password.password_validation_max_length': 'Debe contener menos de %number% caracteres',
      'pages.security.change_password.password_validation_min_length': 'Debe contener más de %number% caracteres',
      'pages.security.change_password.password_validation_number': 'Debe contener al menos un número',
      'pages.security.change_password.password_validation_required': 'Nueva contraseña obligatoria',
      'pages.security.change_password.password_validation_special_char': 'Debe contener al menos un caracter especial',
      'pages.security.change_password.passwords_must_be_equals': 'Las contraseñas deben ser iguales',
      'pages.security.change_password.title': 'Cambiar contraseña',
      'pages.security.change_password.title_change_password': 'Cambio de contraseña',
      'pages.security.login.button_sign_in': 'Entrar',
      'pages.security.login.forgot_password': '¿Has olvidado tu contraseña?',
      'pages.security.login.input_email_placeholder': 'Correo electrónico',
      'pages.security.login.input_email_validation_required': 'El campo email es requerido',
      'pages.security.login.input_password_placeholder': 'Contraseña',
      'pages.security.login.input_password_validation_required': 'El campo contraseña es requerido',
      'pages.security.login.modals.error.body': 'Por favor compruebe sus credenciales',
      'pages.security.login.modals.error.title': 'Error al hacer login',
      'pages.security.login.modals.invalid.body': 'Por favor compruebe sus credenciales',
      'pages.security.login.modals.invalid.title': 'Credenciales inválidas',
      'pages.security.login.title': 'Inicio de sesión',
      'pages.security.reset_password.modals.error.body': 'Ocurrió un error al reiniciar la contraseña',
      'pages.security.reset_password.modals.error.title': 'Error',
      'pages.security.reset_password.modals.success.body': 'Por favor inicie sesión con su nueva contraseña',
      'pages.security.reset_password.modals.success.title': 'Contraseña reiniciada correctamente',
      'pages.security.reset_password_email.already_have_account': '¿Ya tienes una cuenta?',
      'pages.security.reset_password_email.button_reset_password': 'Reiniciar contraseña',
      'pages.security.reset_password_email.email_placeholder': 'Email',
      'pages.security.reset_password_email.email_required': 'Email obligatorio',
      'pages.security.reset_password_email.modals.error.body': 'Ocurrió un error al enviar el email de recuperación',
      'pages.security.reset_password_email.modals.error.title': 'Error',
      'pages.security.reset_password_email.modals.success.body': 'Recibirá un enlace para recuperar su contraseña',
      'pages.security.reset_password_email.modals.success.title': 'Email de reinicio de contraseña enviado',
      'pages.security.reset_password_email.sign_in': 'Identifícate',
      'pages.security.reset_password_email.title': 'Reiniciar contraseña',
      'pages.tracking.email.title': 'Seguimiento de email',
      'planning.comment': 'Comentario',
      'planning.company': 'Empresa',
      'planning.date': 'Fecha',
      'planning.getting_events': 'Recuperando eventos',
      'planning.lead': 'Lead',
      'planning.no_events': 'No hay eventos.',
      'planning.user': 'Usuario',
      'pwa.update_service.body': 'Leadin se actualizará automáticamente.',
      'pwa.update_service.title': 'Nueva versión disponible.',
      'response.no': 'No',
      'response.yes': 'Sí',
      'response.is_active': 'Activa',
      'response.is_not_active': 'Desactivada',
      'response.is_positive': 'Regla positiva',
      'response.is_negative': 'Regla negativa',
      'shared.brands': 'Marcas',
      'shared.channels': 'Canales',
      'shared.companies': 'Empresas',
      'shared.create_new_origin': 'Crear nuevo origen',
      'shared.dealers': 'Instalaciones',
      'shared.from': 'De',
      'shared.label_not_found': 'No se encuentran resultados',
      'shared.search': 'Buscar',
      'shared.select_all': 'Seleccionar todo',
      'shared.select_element': 'Seleccione un elemento',
      'shared.to': 'Para',
      'shared.types': 'Tipos',
      'shared.types_of_leads': 'Tipos de Lead',
      'shared.unselect_all': 'Deseleccionar todo',
      'shared.users': 'Usuarios',
      'shared.modules': 'Módulos',
      'shared.load_more': 'Cargar más',
      'stock_360.brand.label': 'Marca',
      'stock_360.company_name.label': 'Empresa',
      'stock_360.model.label': 'Modelo',
      'stock_360.installation.label': 'Instalación',
      'stock_360.kms.label': 'Kms',
      'stock_360.load_more.button': 'Cargar más',
      'stock_360.loading.button': 'Cargando',
      'stock_360.registration.label': 'Matriculación',
      'stock_360.classification.label': 'Clasificación',
      'stock_360.gearbox.label': 'Caja de cambios',
      'stock_360.fuel.label': 'Combustible',
      'stock_360.price.label': 'Contado',
      'stock_360.email_modal.message1': 'Le adjunto toda la información del vehículo:',
      'stock_360.email_modal.message2': 'Un saludo.',
      'stock_360.email_modal.subject': 'Información del vehículo',
      'stock_360.email_modal.vehicle_card.financed_price.label': 'Precio financiado',
      'stock_360.email_modal.vehicle_card.fuel.label': 'Combustible',
      'stock_360.email_modal.vehicle_card.gearbox.label': 'Caja de cambios',
      'stock_360.email_modal.vehicle_card.mileage.label': 'Kms',
      'stock_360.email_modal.vehicle_card.price.label': 'Precio al contado',
      'stock_360.email_modal.vehicle_card.registration.label': 'Matriculado en',
      'stock_360.email_modal.vehicle_card.classification.label': 'Clasificación',
      'stock_360.financed_price.label': 'Financiado',
      'stock_360.filter.brand.label': 'Marca',
      'stock_360.filter.company_name.label': 'Empresa',
      'stock_360.filter.clean_filters.button': 'Limpiar filtros',
      'stock_360.filter.financed_price.label': 'Financiación',
      'stock_360.filter.fuel.label': 'Combustible',
      'stock_360.filter.gearbox.label': 'Caja de cambios',
      'stock_360.filter.installation.label': 'Instalación',
      'stock_360.filter.legend': 'Segmentación de existencias',
      'stock_360.filter.model.label': 'Modelo',
      'stock_360.filter.mileage.label': 'Kms',
      'stock_360.filter.price.label': 'Contado',
      'stock_360.filter.registration.label': 'Matriculación',
      'stock_360.filter.search.button': 'Buscar',
      'stock_360.gallery.company_name.label': 'Empresa',
      'stock_360.gallery.financed_price.label': 'Precio financiado',
      'stock_360.gallery.fuel.label': 'Combustible',
      'stock_360.gallery.gearbox.label': 'Caja de cambios',
      'stock_360.gallery.installation.label': 'Instalación',
      'stock_360.gallery.kms.label': 'kms',
      'stock_360.gallery.price.label': 'Precio al contado',
      'stock_360.gallery.registration.label': 'Matriculado en',
      'stock_360.gallery.classification.label': 'Clasificación',
      'stock_360.send_info.button': 'Enviar info',
      'stock_360.vehicles_not_found.error': 'Ha ocurrido un error al obtener la información.',
      'stock_360.vehicles_not_found.message': 'No se han encontrado valores en la búsqueda.',
      'table.no_data_display': 'No hay datos para mostrar',
      'template.import.header.brand': 'Marca',
      'template.import.header.channel': 'Canal',
      'template.import.header.comment': 'Comentario',
      'template.import.header.dealer': 'Instalación',
      'template.import.header.description_model': 'Modelo',
      'template.import.header.email': 'Email',
      'template.import.header.vat': 'NIF',
      'template.import.header.name_and_lastname': 'Nombre y apellidos',
      'template.import.header.origin': 'Origen',
      'template.import.header.phone': 'Teléfono',
      'template.import.header.postal_code': 'Código postal',
      'template.import.header.type': 'Tipo',
      'template.import.header.id': 'ID',
      'template.import.header.status': 'Estado',
      'template.import.header.createdAt': 'Fecha Creación',
      'template.import.header.on_track_date': 'Fecha Seguimiento',
      'template.import.header.temp': 'Temperatura',
      'template.import.header.close_date': 'Fecha Venta Cerrada',
      'template.import.header.archived_date': 'Fecha Archivado',
      'template.import.header.archived_type': 'Motivo Archivado',
      'template.import.header.archived_comment': 'Comentario Archivado',
      'template.import.header.user': 'Usuario',
      'template.import.header.close_comment': 'Comentario Venta Cerrada',
      'template.import.header.on_track_comment': 'Comentario Seguimiento',
      'template.import.header.plate': 'Matrícula',
      'template.import.name_file': 'Plantilla',
      'time.abrv_hours': ' h ',
      'time.abrv_minutes': ' min ',
      'time.abrv_seconds': ' seg ',
      'time.report.chart.contacted.customers': 'Núm. de clientes contactados',
      'time.report.chart.range.time.minutes': 'Rango de tiempos (minutos)',
      'time.report.chart.serie.bussiness_contacted_leads': 'Tiempo comercial',
      'time.report.chart.serie.contacted_leads': 'Tiempo real',
      'timezone.Atlantic/Canary': 'Atlantico/Islas Canarias',
      'timezone.Europe/Lisbon': 'Europa/Lisboa',
      'timezone.Europe/Madrid': 'Europa/Madrid',
      'toast.title.appointment_date_success': 'Cita de lead',
      'toast.title.lead_archived_success': 'Lead archivado',
      'toast.title.lead_close_error': 'Error al cerrar lead',
      'toast.title.lead_revert_close_error': 'Error al cancelar la venta',
      'toaster.add_comment.error.title': 'Error al añadir comentario',
      'toaster.add_comment.success.body': 'El comentario ha sido añadido correctamente.',
      'toaster.add_comment.success.title': 'Comentario añadido',
      'toaster.body.delivery_method_changed': 'El método de notificación ha sido modificado correctamente.',
      'toaster.body.last_name_changed': 'Los apellidos del usuario han sido modificados correctamente.',
      'toaster.body.name_changed': 'El nombre del usuario ha sido modificada correctamente.',
      'toaster.body.phone_number_changed': 'El teléfono del usuario ha sido modificado correctamente.',
      'toaster.body.sign_changed': 'La firma del usuario ha sido modificada correctamente.',
      'toaster.call.error': 'No se ha realizado la llamada',
      'toaster.call.error.body': 'No se ha realizado la llamada correctamente',
      'toaster.call.error.body.another.started.call': 'Hay otra llamada en curso',
      'toaster.call.error.no_equal_lead_id': 'Problema al recuperar la información del lead. Inténtelo de nuevo.',
      'toaster.call.success': 'Llamada finalizada con éxito',
      'toaster.call.success.body': 'La llamada se ha completado satisfactoriamente',
      'toaster.configuration_error': 'Error en la configuración',
      'toaster.configuration_error.generic_fail': 'Fail',
      'toaster.configuration_error.message': 'No se ha configurado correctamente el horario laboral.',
      'toaster.edit.lead.error': 'Error al editar un lead',
      'toaster.edit.lead.error.body': 'Ha ocurrido un error inesperado en la edición del lead',
      'toaster.edit.lead.success': 'Lead editado correctamente.',
      'toaster.edit.lead.success.body': 'El lead seleccionado se ha editado correctamente',
      'toaster.email.error': 'Error en el envio de email',
      'toaster.email_sent': 'Email enviado',
      'toaster.email_sent.message': 'Email enviado correctamente a',
      'toaster.error.body.delivery_method_changed': 'Ha ocurrido un error al modificar el método de notifiación del usuario.',
      'toaster.error.body.last_name_changed': 'Ha ocurrido un error al modificar los apellidos del usuario.',
      'toaster.error.body.name_changed': 'Ha ocurrido un error al modificar el nombre del usuario.',
      'toaster.error.body.phone_number_changed': 'Ha ocurrido un error al modificar el teléfono del usuario.',
      'toaster.error.body.phone_number_invalid': 'El teléfono no es válido.',
      'toaster.error.body.sign_changed': 'Ha ocurrido un error al modificar la firma del usuario.',
      'toaster.error.title.profile': 'Error al actualizar el perfil',
      'toaster.error.title.sign_changed': 'Error al modificar firma',
      'toaster.integration.error': 'Integración fallida',
      'toaster.integration.success': 'Integración exitosa',
      'toaster.integration.success_body': 'El lead ha sido integrado correctamente con el sistema externo',
      'toaster.lead.assigned.error': 'Error al asignar el lead',
      'toaster.lead.assigned.error.body': 'Ha ocurrido un error inesperado en la asignación del lead',
      'toaster.lead.assigned_success': 'Lead asignado correctamente.',
      'toaster.lead.assigned_sucess_body': 'Los leads seleccionados se han asignado correctamente.',
      'toaster.lead.deleted.error': 'Error al eliminar el lead',
      'toaster.lead.deleted.error.body': 'Se ha producido un error inesperado en la eliminación del lead',
      'toaster.lead.deleted.success': 'Lead eliminado correctamente',
      'toaster.lead.deleted.success.body': 'Los leads seleccionados se han eliminado correctamente',
      'toaster.lead.edited.error': 'Error al editar el lead',
      'toaster.lead.edited.error.body': 'Se ha producido un error inesperado en la edición del lead',
      'toaster.lead.edited.success': 'Lead editado correctamente',
      'toaster.lead.edited.success.body': 'Los leads seleccionados se han editado correctamente',
      'toaster.lead.get.error': 'Error al recuperar el lead',
      'toaster.lead.on_track': 'Lead en seguimiento',
      'toaster.lead.status_on_track_changed': 'El estado de seguimiento del lead ha sido actualizado',
      'toaster.lead.transfered.error': 'Error al transferir un lead',
      'toaster.lead.transfered.error.body': 'Ha ocurrido un error inesperado en la transferencia del lead',
      'toaster.lead_reminder_success': 'Se ha añadido el recordatorio al Lead correctamente.',
      'toaster.lead_remove_event_success': 'Se ha eliminado el evento correctamente.',
      'toaster.lead_status.closed': 'Venta cerrada',
      'toaster.lead_transfered_success': 'Lead transferido correctamente.',
      'toaster.lead_transfered_success_body': 'Los leads seleccionados han sido transferido correctamente.',
      'toaster.new.investment_new.success': 'Inversión creada correctamente',
      'toaster.new.investment_new.success.body': 'La inversión se ha creado correctamente',
      'toaster.new.investment_edit.success': 'Inversión editada correctamente',
      'toaster.new.investment_edit.success.body': 'La inversión se ha editado correctamente',
      'toaster.new.lead.error': 'Error en la creación del lead',
      'toaster.new.rule.error': 'Error en la creación de las reglas',
      'toaster.new.rule.unhandled_error': 'No se han podido crear las reglas debido a un error',
      'toaster.new.repeated_rule.error.title': 'Existen reglas repetidas',
      'toaster.new.repeated_rule.error.body': 'No se han podido crear REPLACE_THIS reglas porque están repetidas',
      'toaster.new.lead.error.body': 'Ha ocurrido un error inesperado en la creación del lead',
      'toaster.new.lead.success': 'Lead creado correctamente',
      'toaster.new.lead.success.body': 'El lead se ha creado correctamente',
      'toaster.new.rules.title': 'Creación de reglas de asignación',
      'toaster.new.rules.success.body': 'Se han creado REPLACE_THIS reglas correctamente',
      'toaster.saved_configuration': 'Configuración guardada',
      'toaster.saved_configuration.message': 'Se ha guardado correctamente la configuración para la empresa seleccionada',
      'toaster.saved_hours': 'Horas grabadas',
      'toaster.saved_hours.update_message': 'Se ha actualizado correctamente la configuración de horario laboral',
      'toaster.lead_table_visibility': 'Visualización de tabla leads actualizada',
      'toaster.lead_table_visibility.update_message': 'Se ha actualizado correctamente la configuración de la tabla de leads',
      'toaster.title.lead_reminder_success': 'Recordatorio añadido',
      'toaster.title.lead_remove_event_success': 'Evento eliminado',
      'toaster.title.profile': 'Perfil actualizado correctamente',
      'toaster.title.sign_changed': 'Firma modificada correctamente',
      'toaster.visit_confirmation.success': 'Reporte de visita realizado con éxito',
      'toaster.visit_confirmation.sucess.body': 'El reporte de la visita se ha completado satisfactoriamente',
      'toaster.whatsapp.error': 'Error en el envio de WhatsApp',
      'toaster.whatsapp.succes.title': 'Whatsapp enviado',
      'toaster.whatsapp.success_body': 'Mensaje de whatsapp enviado correctamente',
      'toaster.quotations.load.error': 'Error al cargar los presupuestos',
      'toasts.messages.appointment_date_success': 'Cita de lead guardada correctamente.',
      'toasts.messages.lead_archived_success': 'El lead ha sido archivado correctamente',
      'toasts.messages.lead_close_success': 'El lead ha sido cerrado correctamente',
      'toasts.create_rules.too_many_rows.title': 'Límite de creación de reglas alcanzado',
      'toasts.create_rules.too_many_rows.body': 'Se han intentado crear REPLACE_THIS reglas, pero el límite son 300.',
      'tracking.email.true': 'Activo',
      'tracking.email.false': 'Desactivado',
      'user.email': 'Email',
      'user.password': 'Contraseña',
      'user.profile': 'Perfil',
      'user.rules': 'Reglas Asign.',
      'user.save_signature': 'Guardar firma',
      'user.schedule': 'Horario',
      'user.role.legend': 'Rol de usuario',
      'user.role.role_superadmin': 'Super Administrador',
      'user.role.role_user': 'Vendedor',
      'user.role.role_admin': 'Administrador',
      'user.role.role_bdc': 'BDC',
      'user.role.role_dapda': 'Dapda',
      'vehicle.classification.used_vehicle': 'Ocasión',
      'vehicle.classification.zero_mileage': 'km 0',
      'vehicle.classification.brand_new': 'A estrenar',
      'vehicle.classification.buyback': 'Buyback',
      'vehicle.classification.pre_owned_manager': 'Gerencia',
      'vehicle.classification.demo': 'Demo',
      'vehicle.classification.courtesy': 'Cortesía',
      'vehicle.classification.bargain': 'Ganga',
      'vehicle.classification.nearly_new': 'Seminuevo',
      'vehicle.classification.sold': 'Vendido',
      'vehicle.classification.external': 'Vehículo externo',
      'vehicle.classification.remarketing': 'Remarketing',
      'vehicle.status.available': 'Libre',
      'vehicle.status.overhaul': 'Reacondicionamiento',
      'vehicle.status.order': 'Pedido realizado',
      'vehicle.status.reserved': 'Reservado con cliente',
      'vehicle.status.sold': 'Vendido',
      'vehicle.status.scrapyard': 'Desguace',
      'vehicle.status.deactivate': 'Baja otros motivos',
      'vehicle.status.transferred': 'Cedido',
      'vehicle.status.not_available': 'No disponible',
      'quotation.temperature': 'Temperatura',
      'quotation.status.pending' : 'Pendiente',
      'quotation.status.contract' : 'Contrato',
      'quotation.status.reserved' : 'Reservado',
      'quotation.status.missed' : 'No interesado',
      'quotation.status.sold' : 'Vendido',
      'quotation.status.unknown' : 'Desconocido',
      'modals.confirm.title': '¿Estas seguro?',
      'modals.confirm.message': 'Recuerda que esta acción no se puede revertir',
      'assignment.rules.table.row.everything': 'Todos',
      'assignment.rules.table.row.everything_2': 'Todas',
      'assignment.rules.table.row.button.activate': 'Activada',
      'assignment.rules.table.row.button.desactivate': 'Desactivada',
      'toaster.saved_assignmentrule': 'Regla guardada',
      'toaster.saved_assignmentrule.message': 'Se ha guardado correctamente la regla de asignación de leads',
      'toaster.deleted_assignmentrule': 'Regla borrada',
      'toaster.deleted_assignmentrule.message': 'Se ha borrado correctamente la regla de asignación de leads',
      'toaster.deleted_investment.title': 'Inversión borrada',
      'toaster.deleted_investment.body': 'Se ha borrado la inversión seleccionada',
      'modals.assignmentrule.edit.title': 'Editar regla de asignación',
      'modals.assignmentrule.edit.negative_rule': 'Regla negativa',
      'modals.assignmentrule.edit.user': 'Usuario',
      'modals.assignmentrule.edit.name': 'Nombre',
      'toaster.lead.assignmentrule.success': 'Edición correcta',
      'toaster.lead.assignmentrule.success.body': 'La regla seleccionada de ha editado correctamente',
      'toaster.lead.assignmentrule.error': ' Ha ocurrido un error',
      'toaster.lead.assignmentrule.error.body': ' Ha ocurrido un error al editar la regla de asignación seleccionado',
      'toaster.lead.assignmentrule.repeat': ' Regla repetida',
      'toaster.lead.assignmentrule.repeat.body': 'Ya existe una regla de asignación con las mismas características',
      // TODO Translate 'modals.appointment.choose_when': 'Fecha de cita:'

    };

}
